document.querySelectorAll('.fg-hero').forEach(function(root) {
  var bar = root.querySelector('.fg-hero__press-bar');
  if (!bar) return;

  var track = bar.querySelector('.fg-hero__press-items');
  var items = track ? track.querySelectorAll('.fg-hero__press-item') : [];
  if (!track || items.length < 2) return;

  var current = 0;
  var total = items.length;
  var autoTimer = null;
  var touchStartX = 0;
  var isMobile = false;

  function goTo(idx) {
    current = (idx + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
  }

  function next() { goTo(current + 1); }

  function startAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(next, 3000);
  }

  function stopAuto() {
    clearInterval(autoTimer);
  }

  function enable() {
    isMobile = true;
    goTo(current);
    startAuto();
  }

  function disable() {
    isMobile = false;
    stopAuto();
    track.style.transform = '';
  }

  function check() {
    if (window.innerWidth < 768) {
      if (!isMobile) enable();
    } else {
      if (isMobile) disable();
    }
  }

  track.addEventListener('touchstart', function(e) {
    if (!isMobile) return;
    touchStartX = e.touches[0].clientX;
    stopAuto();
  }, { passive: true });

  track.addEventListener('touchend', function(e) {
    if (!isMobile) return;
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
    }
    startAuto();
  }, { passive: true });

  window.addEventListener('resize', check);
  check();
});

document.querySelectorAll('.fg-hero').forEach(function (root) {
  var btn = root.querySelector('.fg-hero__btn');
  var variantId = root.getAttribute('data-trial-variant-id');
  var discountCode = root.getAttribute('data-trial-discount-code');
  if (!btn || !variantId || !discountCode) return;

  btn.addEventListener('click', function (event) {
    var fallback = btn.getAttribute('href');
    event.preventDefault();
    btn.style.pointerEvents = 'none';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.href = '/discount/' + discountCode + '?redirect=/checkout';
      })
      .catch(function () {
        window.location.href = fallback;
      });
  });
});
